<template>
    <div class="container">
        <b-modal
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.identificacion }}</label>
                        <b-form-input
                            v-model="form.identificacion"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.digitoVerif }}</label>
                        <b-form-input
                            v-model="form.digito_verificacion"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.nombre }}</label>
                        <b-form-input
                            v-model="form.nombre"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.correo }}</label>
                        <b-form-input
                            v-model="form.correo"
                            type="email"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.telefono }}</label>
                        <b-form-input
                            v-model="form.telefono"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.direccion }}</label>
                        <b-form-input
                            v-model="form.direccion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.tipoTercero }}</label>
                        <b-form-select
                            v-model="form.tipo_tercero"
                            class="reset-input"
                        >
                            <option value="">
                                {{ labels.select }}
                            </option>
                            <option
                                v-for="tercero in listTipoTercero"
                                :key="tercero.id"
                                :value="tercero.tipo_tercero"
                            >
                                {{ tercero.descripcion }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="reset-btn-delete me-auto"
                            @click="eliminaRegistro()"
                        >
                            {{ labels.delete }}
                        </b-button>
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTercero()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteTercero" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>

import Tercero from '../../services/Tercero'; 
import TipoTerceros from '../../services/TipoTerceros'; 
import InacticaItem from '../utils/InacticaItem.vue'; 

export default {
    name:'Editar',
    props: {
        modalEditar: {
            type: Boolean,
            required: true
        },
        infoTercero: {
            type: Object,
            default: () => ({})
        }
    },
    components: {InacticaItem},
    data() {
        return {
            form: {
                id: null,
                identificacion: "",
                digito_verificacion: "",
                nombre: "",
                correo: "",
                telefono: "",
                direccion: "",
                tipo_tercero: ""
            },
            listTipoTercero: [],
            deleteTercero: false,
            idTercero: null
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar Tercero',
                    save : 'Guardar',
                    delete : 'Eliminar',
                    close : 'Cerrar',
                    identificacion : 'Identificación',
                    digitoVerif : 'Digito verificación',
                    nombre : 'Nombre',
                    correo : 'Correo',
                    telefono : 'Telefono',
                    direccion : 'Dirección',
                    tipoTercero : 'Tipo tercero',
                    select : 'Seleccione...',
                    formInfoTitle: "Datos del tercero", 
                    formInfoSubtitle: "Actualiza la información del tercero y guarda los cambios." 
                }
            }else{
                return {
                    title : 'Edit Third',
                    save : 'Save',
                    delete : 'Eliminar',
                    close : 'Close',
                    identificacion : 'ID',
                    digitoVerif : 'Verification digit',
                    nombre : 'Name',
                    correo : 'Email',
                    telefono : 'Phone',
                    direccion : 'Address',
                    tipoTercero : 'Tipo tercero',
                    select : 'Select...',
                    formInfoTitle: "Third-party details",
                    formInfoSubtitle: "Update the third party's information and save the changes." 
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        cierraModalDelet(){
            this.deleteTercero = false 
        },
        guardarTercero(){
            
            if (
                !this.form.identificacion ||
                !this.form.nombre.trim() ||
                !this.form.correo.trim() ||
                !this.form.telefono ||
                !this.form.direccion.trim() ||
                !this.form.tipo_tercero
            ) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }
                const info = {
                    id: this.form.id,
                    identificacion: this.form.identificacion,
                    digitoVerificacion: this.form.digito_verificacion,
                    nombre: this.form.nombre,
                    correo: this.form.correo,
                    telefono: this.form.telefono,
                    direccion: this.form.direccion,
                    tipoTercero: this.form.tipo_tercero,
                    idUser: this.$store.state.userId
                }

                Tercero.updateTerceroById(info) 
                .then((res) => { 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        this.$emit("actualizado");
                        this.cierraModal();
                    
                    }else if(res.status == 204){ 
                        this.$toast.error('Tercero ingresado ya existe.') 
                    }
                })
                .catch((error) => { console.log(error) })
        },
        eliminaRegistro(){
            this.idTercero = this.form.id
            this.deleteTercero = true 
        },
        confirmInactivate(){
            Tercero.deleteTercero(this.idTercero) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("eliminado");
                    this.cierraModalDelet();
                    this.cierraModal();
                }
            })
            .catch((error) => error) 
        }
    },
    watch: {
        infoTercero: {
            immediate: true,
            handler(value) {
                if (!value) return;
                Object.assign(this.form, value);
            }
        }
    },
    mounted(){
        TipoTerceros.getAllTipoTerceros() 
        .then((res) => { 
            // console.log(res.data.listTipoTerceros); 
            this.listTipoTercero = res.data.listTipoTerceros 
        })
        .catch((error) => {console.log(error)}) 
    }
}
</script>

<style>

</style>
